/* Appstle supplies the purchase options, prices and selling_plan input.
   This bridge positions its widget inside the original Shopify product form. */
(() => {
  let initAttempted = false;
  let attempts = 0;
  let scheduled = false;

  function arrange() {
    document.querySelectorAll('[data-ic-subscription-slot]').forEach(slot => {
      const form = slot.closest('form');
      if (!form) return;
      const widget = form.querySelector('.appstle_sub_widget');
      if (widget && !slot.contains(widget)) slot.append(widget);
      const note = slot.querySelector('[data-ic-subscription-note]');
      if (note) {
        note.hidden = !!widget || attempts < 15;
        note.textContent = slot.dataset.hasPlans === 'true'
          ? 'Theme editor only: this product has selling plans, but the Appstle widget has not loaded. Check App embeds and ask Appstle to confirm installation on this draft theme.'
          : 'Theme editor only: no selling plans are assigned to this product. Add the product and its variants to a plan in Appstle before subscription options can appear.';
      }
    });
  }

  function check() {
    attempts += 1;
    arrange();
    const eligible = document.querySelector('[data-ic-subscription-slot][data-has-plans="true"]');
    if (eligible && !document.querySelector('.appstle_sub_widget') &&
        document.readyState === 'complete' && typeof window.appstleInit === 'function' && !initAttempted) {
      initAttempted = true;
      try { window.appstleInit(); } catch (_) { /* The editor note gives setup guidance if the embed cannot initialise. */ }
    }
    if (attempts < 20) window.setTimeout(check, 500);
  }

  const observer = new MutationObserver(records => {
    if (!records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches?.('.appstle_sub_widget, [data-ic-subscription-slot]') ||
        node.querySelector?.('.appstle_sub_widget, [data-ic-subscription-slot]'))))) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; arrange(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => { attempts = 0; check(); });
  check();
})();
